import React, { Component } from 'react'
import { bindActionCreators} from 'redux'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {Breadcrumb} from 'semantic-ui-react'
import {
    loadRelationById
} from '../../actions/relation'
import PropTypes from 'prop-types'
import Dls from '../../lib'
import RelationForm from '../forms/relations/Relation'

class RelationEditPage extends Component {
    //access router
    //this.props.history.push('/dashboard')
    componentDidMount() {
        const {jwt} = this.props;
        const {id, type} = this.props.match.params;
        if (id === 'new') {
            this.props.loadRelationById(jwt, id, _.upperFirst(type));
        } else {
            if (parseInt(id) !== parseInt(this.props.model.id)) {
                this.props.loadRelationById(jwt, id, _.upperFirst(type));
            }
        }
    }
    
    render() {
        const {model} = this.props;
        const {type} = this.props.match.params;
        return (
            <div>
                {_.isEmpty(model) ? <div></div> : 
                    <div>
                        <div className="row">
                            <div className="col-md-12">
                                <Breadcrumb size="huge">
                                    <Breadcrumb.Section>
                                        Relations
                                    </Breadcrumb.Section>
                                    <Breadcrumb.Divider />
                                    <Breadcrumb.Section>
                                        <Link
                                            to={`/${_.toLower(type)}s/${Dls.pagination.relations(type)}`}
                                        >
                                            {_.upperFirst(type)}s
                                        </Link>
                                    </Breadcrumb.Section>
                                    <Breadcrumb.Divider />
                                    <Breadcrumb.Section>
                                        {model.id ? model.company_name : `Create New ${type}`}
                                    </Breadcrumb.Section>
                                </Breadcrumb>
                            </div>
                        </div>
                        <div className="row" style={{marginTop: '5px'}}>
                            <div className="col-md-12">
                                <RelationForm 
                                    history={this.props.history}
                                />
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

RelationEditPage.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    loadRelationById: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt,
        model: state.relation.model
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        loadRelationById
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(RelationEditPage)


// WEBPACK FOOTER //
// ./src/components/relations/RelationEdit.js